"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var getClientSideSplitTreatments_1 = __importDefault(require("./getClientSideSplitTreatments"));
var LOADING_STATE = Object.freeze({
    isLoading: true,
    treatments: {},
});
var useClientSideSplitTreatments = function (treatmentNames, splitKey, options) {
    if (options === void 0) { options = {}; }
    var _a = (0, react_1.useState)(LOADING_STATE), treatments = _a[0], setTreatments = _a[1];
    (0, react_1.useEffect)(function () {
        setTreatments(LOADING_STATE);
        (0, getClientSideSplitTreatments_1.default)(treatmentNames, splitKey, {
            apiPathString: options.apiPathString,
            attributes: options.attributes,
        }).then(function (treatments) {
            setTreatments({ isLoading: false, treatments: treatments });
        });
    }, [JSON.stringify(treatmentNames)]);
    return treatments;
};
exports.default = useClientSideSplitTreatments;
